// O repo não tem estilo de foco global: todo controle novo traz o seu.
export const FOCO =
    "focus-visible:outline-2 focus-visible:outline-brand focus-visible:outline-offset-2"
